import {
  ControlledDatePicker,
  ControlledRadioButton
} from '@@viewCommonComponents/controlled/index.js';
import { isRequiredBoolean, isRequiredInput } from '@@viewHelpers/validations/index.js';
import booleanOptions from '@@viewCommonComponents/forms/options/index.js';

const CustomerIsCSS = ({ getMiddleText, getMiddleBoolean, form }) => {
  const isCSS = form.watch('customer.socialSecurities.0.isCSS');
  const dateCSS = form.watch('customer.socialSecurities.0.dateCSS');

  return (
    <>
      <ControlledRadioButton
        containerClassName="w-full"
        label={getMiddleText('ADHERENT_CSS_LABEL')}
        id="customer.socialSecurities.0.isCSS"
        name="customer.socialSecurities.0.isCSS"
        booleanValue
        form={form}
        rules={isRequiredBoolean(getMiddleBoolean('ADHERENT_CSS_EST_OBLIGATOIRE'))}
        options={booleanOptions}
        data-testid="ADHERENT_CSS"
        isDisplayed={getMiddleBoolean('ADHERENT_CSS_EST_NECESSAIRE')}
      />

      <ControlledDatePicker
        name="customer.socialSecurities.0.dateCSS"
        label={getMiddleText('ADHERENT_CSS_ACTIVATION_DATE_LABEL')}
        form={form}
        withIndicator={getMiddleBoolean('ADHERENT_CSS_ACTIVATION_DATE_EST_OBLIGATOIRE') || dateCSS}
        rules={isRequiredInput(getMiddleBoolean('ADHERENT_CSS_ACTIVATION_DATE_EST_OBLIGATOIRE'))}
        data-testid="ADHERENT_CSS_ACTIVATION_DATE"
        isDisplayed={getMiddleBoolean('ADHERENT_CSS_ACTIVATION_DATE_EST_NECESSAIRE') && isCSS}
      />
    </>
  );
};

export default CustomerIsCSS;
